import { useEffect, useRef, useState } from "react";
import { getStaticConfigs } from "../../../../../helpers/common";
import Api from "../nominatim";
import CommonComponents from "../../../../Commons";
import { useTranslation } from "react-i18next";
import CommonIcons from "../../../../../assets/icons";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import CloseSvg from "../../../../../assets/svg/close.svg";
import maplibregl from "maplibre-gl";

const SearchOSM = ({ map }: any) =>
{
      const { t } = useTranslation();
      const [enableSearchText, setEnableSearchText] = useState(false);
      const [loading, setLoading] = useState(false);
      const [numberText, setNumberText] = useState(3);
      const [valueSearch, setValueSearch] = useState<any>();
      const [dataAdd, setDataAdd] = useState<any>([]);
      const [visibleSearch, setVisibleSearch] = useState(false);
      const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);
      const checkHaveSave = async () =>
      {
            let dataConfig = await getStaticConfigs();

            return dataConfig?.REACT_APP_MAP_SEARCH_OSM_ENABLE;
      };

      const getNumberText = async () =>
      {
            let dataConfig = await getStaticConfigs();

            return dataConfig?.REACT_APP_MAP_SEARCH_MIN_AUTO_COMPLETE_WORD;
      };

      const renderAdd = (tags: any) =>
      {
            let label = "",
                  address = "",
                  city = "";

            try
            {
                  for (const tag of tags)
                  {
                        if (Array.isArray(tag) && tag.length === 2)
                        {
                              const key = tag[0].toLowerCase();
                              const value = tag[1];

                              if (key === "name")
                              {
                                    label = value;
                              } else if (key === "addr:housenumber")
                              {
                                    address += (address ? ", " : "") + value;
                              } else if (key === "addr:street")
                              {
                                    address += (address ? ", " : "") + value;
                              } else if (key === "addr:suburb")
                              {
                                    address += (address ? ", " : "") + value;
                              } else if (key === "addr:city")
                              {
                                    city = value;
                              }
                        }
                  }
            } catch (error)
            {
                  console.error("Error processing tags:", error);
            }

            let result = label;
            if (label && address)
            {
                  result += ` - ${address}`;
            } else if (address)
            {
                  result += address;
            }
            if (city)
            {
                  result += `, ${city}`;
            }

            return result;
      };

      const renderHandle = async (searchVal?: string) =>
      {
            const val = searchVal ?? valueSearch;
            const minLen = numberText || 3;
            if (!val || val.length < minLen) return;
            try
            {
                  setLoading(true);
                  let resGeocode = await Api.geocode(val);
                  setDataAdd(resGeocode?.data ?? []);
                  setVisibleSearch(true);
            } catch (error)
            {
                  console.error("Search error:", error);
            } finally
            {
                  setLoading(false);
            }
      };

      useEffect(() =>
      {
            const fetchConfig = async () =>
            {
                  const result = await checkHaveSave();
                  setEnableSearchText(result);

                  const res = await getNumberText();
                  setNumberText(res);
            };
            fetchConfig();
      }, []);
      return (
            <div className="block absolute top-3 z-[1000]  left-1/3">
                  {enableSearchText && (
                        <CommonComponents.InputUI
                              className="!w-[343px] rounded-md h-9 !px-2 border border-solid border-[var(--neutral-700)]  !bg-[var(--neutral-950)]"
                              placeholder={t("placerHolderSearch")}
                              value={valueSearch}
                              onChange={(e: any) =>
                              {
                                    const val = e.target.value;
                                    setValueSearch(val);

                                    // debugger
                                    if (debounceRef.current) clearTimeout(debounceRef.current);
                                    if (val?.length >= numberText)
                                    {
                                          debounceRef.current = setTimeout(() =>
                                          {
                                                renderHandle(val);
                                          }, 500);
                                    }
                              }}
                              onKeyDown={(e: any) =>
                              {
                                    if (e.key === "Enter" && valueSearch?.length >= numberText)
                                    {
                                          if (debounceRef.current) clearTimeout(debounceRef.current);
                                          renderHandle();
                                    }
                              }}
                              disabled={loading}
                              prefix={<CommonIcons.SearchIcon />}
                              suffix={
                                    <div
                                          className="w-fit div-one-center shadow-hover"
                                          onClick={() => renderHandle()}
                                          style={{ fontSize: "12px" }}
                                    >
                                          <div className="flex items-center ">
                                                <Spin
                                                      className="mr-2"
                                                      spinning={loading}
                                                      indicator={<LoadingOutlined spin />}
                                                />

                                                {valueSearch?.length > 0 && (
                                                      <img
                                                            src={CloseSvg}
                                                            onClick={(e) =>
                                                            {
                                                                  e.stopPropagation();
                                                                  if (debounceRef.current)
                                                                        clearTimeout(debounceRef.current);
                                                                  setValueSearch("");
                                                                  setVisibleSearch(false);
                                                                  setDataAdd([]);
                                                            }}
                                                            style={{
                                                                  marginRight: "8px",
                                                                  width: "12px",
                                                                  cursor: "pointer",
                                                            }}
                                                      />
                                                )}
                                                {/* <img src={SearchInfoIcon} className="size-3 -rotate-90" /> */}

                                                {/* <div className="!size-4"><CommonIcons.SearchIcon /></div> */}
                                          </div>
                                    </div>
                              }
                        />
                  )}

                  {dataAdd?.length > 0 && visibleSearch && (
                        <div
                              className={`absolute  h-fit max-h-[300px] overflow-auto w-[343px] px-1 top-10 bg-[rgba(30,34,45,0.9)] rounded-lg`}
                              style={{ color: "white" }}
                        >
                              {(() =>
                              {
                                    const elements = [];
                                    for (const [index, data] of dataAdd?.entries())
                                    {
                                          elements.push(
                                                <div
                                                      key={index}
                                                      className="p-2 cursor-pointer hover:bg-common-ink400"
                                                      onClick={() =>
                                                      {
                                                            if (data?.lat && data?.lng)
                                                            {
                                                                  new maplibregl.Marker()
                                                                        .setLngLat([data?.lng, data?.lat])
                                                                        .addTo(map);

                                                                  map.flyTo({
                                                                        center: [data?.lng, data?.lat],
                                                                        zoom: 15,
                                                                        essential: true,
                                                                  });
                                                                  setValueSearch(renderAdd(data?.tags));
                                                                  setVisibleSearch(false);
                                                            } else
                                                            {
                                                                  new maplibregl.Marker()
                                                                        .setLngLat([data?.lon, data?.lat])
                                                                        .addTo(map);

                                                                  map.flyTo({
                                                                        center: [data?.lon, data?.lat],
                                                                        zoom: 15,
                                                                        essential: true,
                                                                  });
                                                                  setValueSearch(data?.name);
                                                                  setVisibleSearch(false);
                                                            }
                                                      }}
                                                >
                                                      <p style={{ color: "white" }}>
                                                            {data?.tags ? renderAdd(data?.tags) : data?.name}
                                                      </p>
                                                </div>,
                                          );
                                    }
                                    return elements;
                              })()}
                        </div>
                  )}

                  {dataAdd?.length === 0 && visibleSearch && (
                        <div
                              className="absolute  h-fit max-h-[300px] overflow-auto w-[343px] px-1 top-10 bg-[rgba(30,34,45,0.9)] rounded-lg"
                              style={{ color: "white" }}
                        >
                              <p className="p-[10px]">{t("No data")}</p>
                        </div>
                  )}
            </div>
      );
};

export default SearchOSM;
